module.exports = __webpack_public_path__ + "static/media/refund.ccbf2448.png";